const MAX_NICKNAME_LENGTH = 64;
const NICKNAME_PATTERN = /^[A-Za-z0-9 _-]+$/;

/**
 * Returns the empty string if nickname is valid, or a string error message if not.
 */
export function validateNickname(nickname: string): string {
  // This logic should be kept in sync with _validate_nickname on the backend.

  nickname = nickname.trim();

  if (!nickname) {
    return "";
  }

  if (nickname.length > MAX_NICKNAME_LENGTH) {
    return "Your nickname is too long.";
  }

  if (!NICKNAME_PATTERN.test(nickname)) {
    return "Your nickname may only contain letters, numbers, dashes, underscores, and spaces.";
  }

  return "";
}
